(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubbo-age-bubbles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bbAges) return;
    window.__bbAges = true;
    var fine = matchMedia('(any-pointer: fine)');
    /* hover a stage: its mascot hops once (bubbo.js skips it under reduced motion and in the editor) */
    document.addEventListener('mouseover', function (e) {
      if (!fine.matches || !(e.target instanceof Element)) return;
      var tile = e.target.closest('[data-bb-ages] .bb-ages__tile');
      if (!tile || (e.relatedTarget instanceof Node && tile.contains(e.relatedTarget))) return;
      var m = tile.querySelector('.bb-mascot');
      if (m && window.Bubbo) window.Bubbo.hop(m);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbo-club"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__bubboClub) return;
    window.__bubboClub = true;

    /* Append the child's month/year as a tag only when both are chosen. No full date of birth, ever. */
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.id.startsWith('BubboClub-')) return;
      const tags = form.querySelector('[data-bb-club-tags]');
      if (!tags) return;
      if (!tags.dataset.base) tags.dataset.base = tags.value;
      const month = form.querySelector('[data-bb-club-month]')?.value || '';
      const year = form.querySelector('[data-bb-club-year]')?.value || '';
      tags.value = /^\d{2}$/.test(month) && /^\d{4}$/.test(year) ? `${tags.dataset.base},child-${year}-${month}` : tags.dataset.base;
    });

    /* Success: both peekers hop and a small burst pops (Bubbo skips both under reduced motion). */
    const celebrate = (scope, tries = 0) => {
      const done = scope.querySelectorAll('[data-bb-club-success]:not([data-bb-done])');
      if (!done.length) return;
      if (!window.Bubbo) {
        if (tries < 30) setTimeout(() => celebrate(scope, tries + 1), 100);
        return;
      }
      done.forEach((message) => {
        message.setAttribute('data-bb-done', '');
        const panel = message.closest('.bb-club__panel');
        setTimeout(() => {
          if (panel) window.Bubbo.hopAll(panel, 140);
          window.Bubbo.burst(message.querySelector('.bb-club__success-icon') || message, { bubbles: 4, sparkles: 3, spread: 60 });
        }, 400);
      });
    };
    const start = () => celebrate(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', (event) => celebrate(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbo-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bbFeature) return;
    window.__bbFeature = true;
    if (!window.IntersectionObserver) return;
    /* the product's mascot hops once when the band first comes into view (bubbo.js skips it under reduced motion) */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        setTimeout(function () { if (window.Bubbo) window.Bubbo.hop(e.target); }, 420);
      });
    }, { threshold: 0.6 });
    function scan(root) {
      (root || document).querySelectorAll('[data-bb-feature] .bb-feature__mascot .bb-mascot').forEach(function (m) { io.observe(m); });
    }
    scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bbHero) return;
    window.__bbHero = true;
    var d = document;
    var reduced = function () {
      var B = window.Bubbo;
      if (B) return B.reducedMotion;
      return matchMedia('(prefers-reduced-motion: reduce)').matches || d.documentElement.classList.contains('bb-static');
    };

    /* the cast springs up once the fonts are in (max 400ms wait) */
    function live(root) {
      var stages = (root || d).querySelectorAll('[data-bb-stage]:not(.is-live)');
      if (!stages.length) return;
      var go = function () { stages.forEach(function (s) { s.classList.add('is-live'); }); };
      var done = false;
      var once = function () { if (!done) { done = true; requestAnimationFrame(go); } };
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(once, once);
      setTimeout(once, 400);
    }

    d.addEventListener('click', function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (!t) return;

      /* "Shop by age" scrolls to the age bubbles on this page; without them it stays a normal link */
      var jump = t.closest('[data-bb-scroll-to]');
      if (jump) {
        var target = d.getElementById(jump.getAttribute('data-bb-scroll-to'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
          var head = target.querySelector('h2, h3');
          if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
        }
        return;
      }

      /* pop bubble: burst + every mascot hops + shipping toast; it floats back after 4s */
      var pop = t.closest('[data-bb-pop]');
      if (pop) {
        var B = window.Bubbo;
        var stage = pop.closest('[data-bb-stage]');
        if (B && !reduced()) {
          B.burst(pop, { bubbles: 8, sparkles: 6, splash: true, spread: 90 });
          pop.classList.add('is-popped');
          B.hopAll(stage, 90);
          clearTimeout(pop._bbBack);
          pop._bbBack = setTimeout(function () { pop.classList.remove('is-popped'); }, 4000);
        }
        if (B && pop.dataset.bbToast) B.toast(pop.dataset.bbToast);
        return;
      }

      /* a tapped mascot says its own line: the static greeting steps aside meanwhile */
      var m = t.closest('[data-bb-hero] [data-bb-tap]');
      if (m) {
        var hero = m.closest('[data-bb-hero]');
        var say = hero && hero.querySelector('.bb-hero__say');
        if (say) {
          say.classList.add('is-hidden');
          clearTimeout(say._bbBack);
          say._bbBack = setTimeout(function () { say.classList.remove('is-hidden'); }, 2900);
        }
      }
    });

    live(d);
    d.addEventListener('shopify:section:load', function (e) { live(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbo-how-to"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bubboHowToVideo) return;
    window.__bubboHowToVideo = true;
    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var opener = target.closest('[data-bb-video-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-bb-video-open'));
        if (!dialog || typeof dialog.showModal !== 'function') return;
        var frame = dialog.querySelector('iframe[data-src]');
        if (frame && !frame.getAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-src'));
        if (!dialog.dataset.bbWired) {
          dialog.dataset.bbWired = '1';
          dialog.addEventListener('close', function () {
            var f = dialog.querySelector('iframe[data-src]');
            if (f) f.removeAttribute('src');
            opener.focus();
          });
          dialog.addEventListener('click', function (e) {
            if (e.target === dialog) dialog.close();
          });
        }
        dialog.showModal();
        return;
      }
      var closer = target.closest('[data-bb-video-close]');
      if (closer) closer.closest('dialog')?.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbo-mom-quotes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__bubboQuotes) return;
    window.__bubboQuotes = true;
    /* Theme editor: selecting a quote block scrolls the phone rail to it. */
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target instanceof Element ? event.target.closest('.bb-quotes__item') : null;
      const track = item?.closest('.bb-quotes__track');
      if (track && track.scrollWidth > track.clientWidth) track.scrollTo({ left: item.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).scrollPaddingLeft || 0), behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbo-night-footer"] && !Shopify.designMode) return;
  try {
    
  /* Age rows in the header dropdown and the mobile menu: "Tiny Dreamers 0 to 6 months" ->
     <span class="bb-age__name">Tiny Dreamers</span> <span class="bb-age__range">0 to 6 months</span>.
     Idempotent; re-applied after Horizon re-renders the header (hydration morph, editor reloads). */
  (function () {
    var RX = /^(.*\S)\s+(\d+\s+to\s+\d+\s+(?:months?|years?))$/i;
    var SEL = '.mega-menu__link .wrap-text, .menu-drawer__menu-item--child .menu-drawer__menu-item-text';
    var OPTS = { childList: true, subtree: true, characterData: true };
    var observer = null;

    function split(root) {
      root.querySelectorAll(SEL).forEach(function (el) {
        if (el.querySelector('.bb-age__range')) return;
        var m = (el.textContent || '').trim().match(RX);
        if (!m) return;
        var name = document.createElement('span');
        var range = document.createElement('span');
        name.className = 'bb-age__name';
        range.className = 'bb-age__range';
        name.textContent = m[1];
        range.textContent = m[2];
        el.replaceChildren(name, ' ', range);
        el.classList.add('bb-age');
      });
    }

    function init() {
      var header = document.getElementById('header-component');
      if (observer) observer.disconnect();
      if (!header) return;
      split(header);
      observer = new MutationObserver(function () {
        observer.disconnect();
        split(header);
        observer.observe(header, OPTS);
      });
      observer.observe(header, OPTS);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
